// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const repositoriesLicensesQuery = gql`
  query vulnerabilityLicensesDetails(
    $input: VulnerabilityLicensesDetailsInput!
  ) {
    vulnerabilityLicensesDetails(input: $input) {
      licenseName
      dependencyCount
      repositoryId
      repositoryName
      dependencies {
        dependencyId
        dependencyName
        dependencyVersion
        repositoryId
        repositoryName
      }
    }
  }
`;
